if (!customElements.get('animated-image')) {
  customElements.define(
    'animated-image',
    class AnimatedImage extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector('img');
        this.button = this.querySelector('.animated-image__toggle');
        this.animatedSrc = this.dataset.animatedSrc;
        this.staticSrc = this.dataset.staticSrc;
        this.button.addEventListener('click', () => this.setPaused(!this.paused));
      }

      connectedCallback() {
        this.setPaused(false);
      }

      setPaused(paused) {
        this.paused = paused;
        this.image.src = paused ? this.staticSrc : this.animatedSrc;
        this.classList.toggle('is-paused', paused);
        this.button.setAttribute('aria-pressed', paused ? 'true' : 'false');
        this.button.setAttribute('aria-label', paused ? this.button.dataset.labelPlay : this.button.dataset.labelPause);
      }
    }
  );
}
